import { render, staticRenderFns } from "./GalleryCard.vue?vue&type=template&id=fa04d8b0&scoped=true&"
import script from "./GalleryCard.vue?vue&type=script&lang=js&"
export * from "./GalleryCard.vue?vue&type=script&lang=js&"
import style0 from "./GalleryCard.vue?vue&type=style&index=0&id=fa04d8b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa04d8b0",
  null
  
)

component.options.__file = "GalleryCard.vue"
export default component.exports